module.exports = __webpack_public_path__ + "img/1-2-3.5714d339.jpg";